import { Button, Breadcrumb, Popconfirm, Space, Switch, Table, Tag, Typography } from "antd";
import { EditOutlined, HomeOutlined, KeyOutlined, PlusOutlined } from "@ant-design/icons";
import { useContext, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { openNotification } from "../../../components/Notification";
import PageHeader from "../../../components/PageHeader";
import { SecaoCard } from "../../../components/SecaoCard";
import { UserContext } from "../../../contexts/UserContext";
import { integracaoDenunciaService } from "../../../services/resources/integracaoDenunciaService";
import {
  OPCOES_TAMANHO_PAGINA,
  podeGerenciarIntegracaoDenuncia,
  urls,
} from "../../../utils";

export const ListIntegracoesDenuncia = () => {
  const history = useHistory();
  const { user } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [paginacao, setPaginacao] = useState({
    currentPage: 0,
    totalElements: 0,
    size: OPCOES_TAMANHO_PAGINA[2] || 20,
  });

  const autorizado = podeGerenciarIntegracaoDenuncia(user);

  useEffect(() => {
    if (autorizado) {
      carregar(0, paginacao.size);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autorizado]);

  async function carregar(page, size) {
    setLoading(true);
    try {
      const { data } = await integracaoDenunciaService.list({ page, size });
      setDados(data.content || []);
      setPaginacao({
        currentPage: data.currentPage,
        totalElements: data.totalElements,
        size: data.size,
      });
    } catch (error) {
      openNotification(
        "error",
        <strong>Erro ao listar integrações</strong>,
        error?.response?.data?.userMessage || error?.response?.data?.detail
      );
    } finally {
      setLoading(false);
    }
  }

  async function alternarAtiva(record, ativa) {
    try {
      if (ativa) {
        await integracaoDenunciaService.ativar(record.codigo);
      } else {
        await integracaoDenunciaService.desativar(record.codigo);
      }
      openNotification("success", <strong>Situação atualizada</strong>);
      carregar(paginacao.currentPage, paginacao.size);
    } catch (error) {
      openNotification(
        "error",
        <strong>Não foi possível alterar a situação</strong>,
        error?.response?.data?.userMessage
      );
    }
  }

  const columns = [
    { title: <strong>nome</strong>, dataIndex: "nome", key: "nome" },
    {
      title: <strong>escopo</strong>,
      key: "escopo",
      render: (record) =>
        record.tipoEscopo === "CANAL"
          ? `Canal: ${record.nomeCanal || "-"}`
          : `Grupo: ${record.abrangenciaGrupo || "-"}`,
    },
    {
      title: <strong>situação</strong>,
      dataIndex: "ativa",
      key: "ativa",
      render: (ativa, record) => (
        <Popconfirm
          title={ativa ? "Desativar esta integração?" : "Ativar esta integração?"}
          onConfirm={() => alternarAtiva(record, !ativa)}
          okText="Sim"
          cancelText="Não"
        >
          <Switch checked={ativa} checkedChildren="ativa" unCheckedChildren="inativa" />
        </Popconfirm>
      ),
    },
    {
      title: <strong>chave</strong>,
      dataIndex: "ultimosCaracteresChave",
      render: (value) => <Typography.Text code>****{value}</Typography.Text>,
    },
    {
      title: <strong>ações</strong>,
      key: "acoes",
      width: 120,
      render: (record) => (
        <Space>
          <Button
            type="primary"
            ghost
            className="action-button"
            title="Editar"
            onClick={() =>
              history.push(
                urls.INTEGRACOES_DENUNCIA_EDITAR.replace(":codigo", record.codigo)
              )
            }
          >
            <EditOutlined />
          </Button>
          <Button
            type="primary"
            className="action-button"
            title="Detalhes"
            onClick={() =>
              history.push(
                urls.INTEGRACOES_DENUNCIA_DETAILS.replace(":codigo", record.codigo)
              )
            }
          >
            <KeyOutlined />
          </Button>
        </Space>
      ),
    },
  ];

  if (!autorizado) {
    return (
      <div id="sectionMain">
        <Tag color="red">Acesso restrito ao grupo OISOL MASTER</Tag>
      </div>
    );
  }

  return (
    <div id="sectionMain">
      <Breadcrumb id="breadcrumb">
        <Breadcrumb.Item>
          <Link to="">
            <HomeOutlined />
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>gerenciamento</Breadcrumb.Item>
        <Breadcrumb.Item>
          <strong>integrações de denúncias</strong>
        </Breadcrumb.Item>
      </Breadcrumb>
      <div className="container-section">
        <PageHeader
          titulo="INTEGRAÇÕES DE DENÚNCIAS"
          extra={[
            <Link to={urls.INTEGRACOES_DENUNCIA_CRIAR} key="nova">
              <Button type="primary" icon={<PlusOutlined />}>
                nova integração
              </Button>
            </Link>,
          ]}
        />
        <SecaoCard>
        <Table
          rowKey="codigo"
          loading={loading}
          columns={columns}
          dataSource={dados}
          pagination={{
            current: paginacao.currentPage + 1,
            pageSize: paginacao.size,
            total: paginacao.totalElements,
            showSizeChanger: true,
            pageSizeOptions: ["8", "20", "50"],
            onChange: (page, pageSize) => carregar(page - 1, pageSize),
          }}
        />
        </SecaoCard>
      </div>
    </div>
  );
};
